import { getDictionary } from '@/shared/lib/i18n';
import { LOG_INFO, logger } from 'config/logger';
import { versionCheckerInterval } from 'config/versionChecker';
import { useContext, useEffect, useMemo } from 'react';
import { SnackbarContext } from 'shared/legacy/contexts/SnackbarContext/SnackbarContext';
import { VersionContextProviderProps } from './types';
import { VersionSnackbar } from './VersionSnackbar';

export const useContainer = ({ children }: VersionContextProviderProps) => {
  const { createSnackbar } = useContext(SnackbarContext);

  useEffect(() => {
    const interval = versionCheckerInterval(({ version }) => {
      createSnackbar(<VersionSnackbar onClick={onClickUpdateVersion} />, {
        persist: true,
        variant: 'loading',
        title: getDictionary().newVersionAvailable,
      });

      logger.info(version, LOG_INFO.DIFF_APP_VERSION);
    });

    return () => {
      clearInterval(interval);
    };
  }, []);

  const onClickUpdateVersion = () => {
    window.location.reload();
  };

  return useMemo(() => ({ children }), []);
};
